import React from "react";
const SvgEnergyclass = props => (
  <svg fill="none" viewBox="0 0 24 25" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M4 6.833a.5.5 0 01.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zm0 3a.5.5 0 01.5-.5h10a.5.5 0 010 1h-10a.5.5 0 01-.5-.5zm0 3a.5.5 0 01.5-.5h12a.5.5 0 110 1h-12a.5.5 0 01-.5-.5zm0 3a.5.5 0 01.5-.5h14a.5.5 0 110 1h-14a.5.5 0 01-.5-.5zm0 3a.5.5 0 01.5-.5h16a.5.5 0 110 1h-16a.5.5 0 01-.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEnergyclass;
